module.exports = __webpack_public_path__ + "img/person-circle.d40d703f.svg";